function formateDate(target, formate = "YYYY-MM-DD hh:mm:ss") {
    // console.log(target)
    if (!target) {
        return "";
    };

    if (target instanceof Date) {

    } else if (Object.prototype.toString.call(target) == "[object String]") {
        target = new Date(target);
    } else {
        return "";
    };
    let yearStr = target.getFullYear() + "";
    let monthStr = (target.getMonth() + 1) > 9 ? (target.getMonth() + 1) + "" : ("0" + (target.getMonth() + 1));
    let dateStr = target.getDate() > 9 ? target.getDate() + "" : "0" + target.getDate();
    let hourStr = target.getHours() > 9 ? target.getHours() + "" : "0" + target.getHours();
    let minuteStr = target.getMinutes() > 9 ? target.getMinutes() + "" : "0" + target.getMinutes();
    let secondStr = target.getSeconds() > 9 ? target.getSeconds() + "" : "0" + target.getSeconds();


    let fieldYearArr = formate.match(/Y/g) || [];
    let yearFiledLength = fieldYearArr.length;
    yearStr = yearStr.substr(4 - yearFiledLength);

    let result = formate.replace(fieldYearArr.join(""), yearStr);
    result = result.replace("MM", monthStr);
    result = result.replace("DD", dateStr);
    result = result.replace("hh", hourStr);
    result = result.replace("mm", minuteStr);
    result = result.replace("ss", secondStr);
    return result;

};

function getWeek(date) {
    if (!date) {
        return "";
    };

    if (date instanceof Date) {

    } else if (Object.prototype.toString.call(date) == "[object String]") {
        date = new Date(date);
    } else {
        return "";
    };
    let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const dayOfWeek = firstDayOfYear.getDay();
    let spendDay = 1;
    if (dayOfWeek != 0) {
        spendDay = 7 - dayOfWeek + 1;
    }
    firstDayOfYear = new Date(date.getFullYear(), 0, spendDay);
    const d = Math.ceil((date.valueOf() - firstDayOfYear.valueOf()) / 86400000);
    let resultWeek = Math.ceil(d / 7);
    return `${date.getFullYear()}第${resultWeek}周`;
}

function getYear(date) {
    return formateDate(date, "YYYY");
}

function getMonth(date) {
    return formateDate(date, "YYYY-MM");

}

export { formateDate, getWeek, getYear, getMonth };